import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getEntityStyle',
})
export class GetEntityStylePipe implements PipeTransform {
  transform(value: unknown): unknown {
    switch (value) {
      case 'PATIENT':
        return 'success';
      case 'FACILITY':
        return 'primary';
      case 'DOCTOR':
        return 'info';
      case 'CLIENT':
        return 'warning';
      default:
        return 'danger';
    }
  }
}
